export default "/assets/images/chair.png?d199cc080ae4b0659a7779f546676548";